export default "__VITE_ASSET__BjYgEMQG__"